import { render, staticRenderFns } from "./BuddyCheckbox.vue?vue&type=template&id=1512a3f2&scoped=true"
import script from "./BuddyCheckbox.vue?vue&type=script&lang=js"
export * from "./BuddyCheckbox.vue?vue&type=script&lang=js"
import style0 from "./BuddyCheckbox.vue?vue&type=style&index=0&id=1512a3f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1512a3f2",
  null
  
)

export default component.exports